// removed by extract-text-webpack-plugin
module.exports = {"modal":"styles-module__modal___111gA","modal-content":"styles-module__modal-content___eo0bF"};


//////////////////
// WEBPACK FOOTER
// ./src/core/ui/Modal/styles.module.css
// module id = 403
// module chunks = 0